import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { db, auth } from '../config/firebase';

/**
 * Write an audit log entry to orgs/{orgId}/auditLog
 * @param {string} orgId
 * @param {string} event  - human-readable event name e.g. "Transaction Added"
 * @param {object} details - optional key/value context (amount, account, etc.)
 */
export const logAudit = async (orgId, event, details = {}) => {
  if (!orgId) return;
  const u = auth.currentUser;
  try {
    await addDoc(collection(db, 'orgs', orgId, 'auditLog'), {
      timestamp: serverTimestamp(),
      event,
      user: {
        email:       u?.email       || 'unknown',
        displayName: u?.displayName || u?.email || 'Unknown',
      },
      details,
    });
  } catch (err) {
    // Audit failures should never break the main action
    console.warn('Audit log write failed:', err);
  }
};
